import { Purchases as NativePurchases } from '@revenuecat/purchases-capacitor';
import { fromNativeOffering } from './map-native';
import { isNative } from './platform';
import type { AppOffering } from './types';

// Fetches the specific named Offering, not just "current" — each screen
// (individual_standard, family_duo_premium, ...) asks for its own offering.
export async function getOffering(offeringIdentifier: string): Promise<AppOffering | null> {
  const all = await listOfferings();
  return all[offeringIdentifier] ?? null;
}

// Native only; web reads the Stripe catalog from the app's API.
export async function listOfferings(): Promise<Record<string, AppOffering>> {
  const out: Record<string, AppOffering> = {};
  if (!isNative()) return out;

  const { all } = await NativePurchases.getOfferings();
  for (const [id, offering] of Object.entries(all)) {
    out[id] = fromNativeOffering(offering);
  }
  return out;
}
